/**
 * CRT scanline overlay. Builds a small horizontally-striped texture and
 * tiles it across the viewport with an additive-dark blend so the whole
 * frame gets a subtle scan pattern without touching individual sprites.
 */

import { Application, Texture, TilingSprite } from 'pixi.js';
import { SCANLINE_ALPHA, SCANLINE_PERIOD_PX } from './style';

export class CrtOverlay {
  readonly sprite: TilingSprite;

  constructor(app: Application) {
    const tex = buildScanlineTexture(SCANLINE_PERIOD_PX);
    this.sprite = new TilingSprite({
      texture: tex,
      width: app.renderer.width,
      height: app.renderer.height,
    });
    this.sprite.alpha = SCANLINE_ALPHA;
  }

  resize(w: number, h: number): void {
    this.sprite.width = w;
    this.sprite.height = h;
  }
}

function buildScanlineTexture(period: number): Texture {
  const canvas = document.createElement('canvas');
  canvas.width = 2;
  canvas.height = period;
  const ctx = canvas.getContext('2d');
  if (!ctx) return Texture.WHITE;
  ctx.fillStyle = 'rgba(0, 0, 0, 0)';
  ctx.fillRect(0, 0, 2, period);
  ctx.fillStyle = 'rgba(0, 0, 0, 1)';
  ctx.fillRect(0, 0, 2, 1);
  return Texture.from(canvas);
}
